module.exports = __webpack_public_path__ + "img/step2-2-sche.ed09e25b.png";